import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { AppButton } from 'apps/promo/components/common/app-button/AppButton';
import { PromoButton } from 'apps/promo/components/common/promo-button/PromoButton';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import PromoComplexPopup from 'apps/promo/components/popup/PromoComplexPopup';
import { ComplexPopupRow } from 'apps/promo/components/popup/styles';
import { URL_IMAGES_I } from 'apps/promo/constants/UrlConstants';
import { useExtra } from 'apps/promo/hooks/selectors';
import promoMedia from 'apps/promo/theme/promoMedia';

const QrCode = styled.figure`
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 136px;
    margin-bottom: 32px;

    img {
        border: none;
        max-width: 100%;
        vertical-align: top;
    }

    ${promoMedia.tablet744} {
        width: 224px;
    }
`;

const isExcludedForCountry = (item, country) => item?.except_countries?.some((c) => c.code_a2 === country);

function QRPopup(props) {
    const extra = useExtra();
    const downloadButtons = extra?.downloadButtons;
    const country = extra?.noAuthFooter?.language?.country?.toUpperCase();

    const byType = {};
    for (const item of downloadButtons ?? []) {
        byType[item.type] = item;
    }

    const getUrl = (item) => {
        if (isExcludedForCountry(item, country)) {
            return undefined;
        }

        return props.isReferral ? item?.url_referral : item?.url;
    };

    const getPicture = () => {
        if (props.isReferral && byType.qr?.qr_code_referral) {
            return (
                <picture>
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={byType.qr?.qr_code_referral?.url} />
                </picture>
            );
        } else if (byType.qr?.qr_code) {
            return (
                <picture>
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={byType.qr?.qr_code.url} />
                </picture>
            );
        } else {
            return (
                <picture>
                    <source media="(min-width: 736px)" srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-d.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-d.png 2x`} />
                    <source srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-m.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-m.png 2x`} />
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={`${URL_IMAGES_I}/smart-qr-code-1x-m.png`} />
                </picture>
            );
        }
    };

    return (
        <PromoComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <ComplexPopupRow>
                <PromoText color="gray40" tag="div" variant="subheader">
                    {byType.qr?.title}
                </PromoText>
            </ComplexPopupRow>
            <QrCode>{getPicture()}</QrCode>
            {props.hasAppsBtns ? (
                <PromoRow flex direction="column" align="center">
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={getUrl(byType.apple)} variant="apple" areaLabel="App Store" />
                    </PromoRow>
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={getUrl(byType.android)} variant="google" areaLabel="Google Play" />
                    </PromoRow>
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={getUrl(byType.huawei)} variant="huawei" areaLabel="AppGallery" />
                    </PromoRow>
                </PromoRow>
            ) : (
                <ComplexPopupRow>
                    <PromoButton caption={byType.qr?.buttonTitle} onClick={() => props.popupRef.current?.close()} variant="primary" isInverted />
                </ComplexPopupRow>
            )}
        </PromoComplexPopup>
    );
}

QRPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    hasAppsBtns: PropTypes.bool,
    chinaChat: PropTypes.bool,
    isReferral: PropTypes.bool,
};

export default QRPopup;
